import { LitElement, html, css } from 'lit'
import {customElement, property, query, state} from 'lit/decorators.js'
import '@shoelace-style/shoelace/dist/themes/light.css'
import '@shoelace-style/shoelace/dist/components/dialog/dialog'
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button'
import '@shoelace-style/shoelace/dist/components/textarea/textarea'
import '@shoelace-style/shoelace/dist/components/icon/icon'
import SlDialog from '@shoelace-style/shoelace/dist/components/dialog/dialog'
import SlTextarea from '@shoelace-style/shoelace/dist/components/textarea/textarea'


@customElement('vxc-input-dialog')
class TInputDialog extends LitElement {
    /** CSS */
    static styles = css`
        :host {
        }
        sl-dialog {
            --width: 20rem;
        }
        sl-textarea {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            resize: none;
        }

        .footer {
            display: flex;
            justify-content: flex-end;
            padding: 1rem 0 0 0;
        }
    `

    /** properties */
    @property({ type: String  })    title:string  = "Input"
    @property({ type: String  })    placeholder:string  = "Saisissez votre texte..."
    @property({ type: String  })    btnCaption:string  = "Envoyer"
    // @state() private value: string = '';
    @query('sl-dialog')   private dialog!: SlDialog;
    @query('sl-textarea') private textarea!: SlTextarea; 

    private handleSave() {
        console.log('handleSave')
        const value = this.textarea?.value
        console.log('dialog returned', value)
        if (value.trim() !== '') {
            console.log('input', value)
            this.dispatchEvent(new CustomEvent('dlg-input', {
                detail: value,
                bubbles: true,
                composed: true
            }))
        }
        this.dialog.hide()
    }

    private handleDialogClose(event: CustomEvent) {
        console.log('dialog closed..')
        this.dispatchEvent(new CustomEvent('dlg-close', {
            detail: 'closed',
            bubbles: true,
            composed: true
        }))
    }

    render() {
        return html`
            <sl-dialog 
                label="${this.title}" 
                @sl-after-hide=${this.handleDialogClose}
                open>
                <sl-textarea
                    filled
                    placeholder="${this.placeholder}"
                ></sl-textarea>

                <div class="footer">
                    <sl-button variant="primary" @click=${this.handleSave}>${this.btnCaption}</sl-button>
                </div>
            </sl-dialog>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-input-dialog': TInputDialog
  }
}